import React from "react";
import ThreeDModel from "./ThreeDModel";

export interface ThreeDViewerSceneProps {
  meshes: THREE.Object3D<THREE.Event>[];
  handleSelectMesh: (mesh: THREE.Mesh) => void;
}

class ThreeDScene extends React.Component<ThreeDViewerSceneProps> {
  renderModel() {
    return this.props.meshes?.map((mesh, idx) => {
      return (
        <ThreeDModel
          key={idx}
          mesh={mesh as THREE.Mesh}
          handleSelectMesh={this.props.handleSelectMesh}
        />
      );
    });
  }

  render(): React.ReactNode {
    return <scene>{this.renderModel()}</scene>;
  }
}

export default ThreeDScene;
